export default __webpack_public_path__ + "static/media/calls-square.6e9be257.jpg";